import React from 'react';
import DraggableToolbarStyled from './DraggableToolbar.styled';
import Toolbar from '@/components/toolbar/Toolbar';
import { ToolbarPositions } from './DraggableToolbar.types';

const DraggableToolbar = () => {
  return (
    <DraggableToolbarStyled id="draggable-toolbar">
      <Toolbar />
      {/* Top Left */}
      <div
        id={ToolbarPositions.TopLeft}
        className="draggable__container draggable-1"
      />
      {/* Top Right */}
      <div
        id={ToolbarPositions.TopRight}
        className="draggable__container draggable-2"
      />
      {/* Center Left (Default) */}
      <div
        id={ToolbarPositions.CenterLeft}
        className="draggable__container draggable-3"
      />
      {/* Center Right */}
      <div
        id={ToolbarPositions.CenterRight}
        className="draggable__container draggable-4"
      />
      {/* Bottom Left */}
      <div
        id={ToolbarPositions.BottomLeft}
        className="draggable__container draggable-5"
      />
      {/* Bottom Right */}
      <div
        id={ToolbarPositions.BottomRight}
        className="draggable__container draggable-6"
      />
    </DraggableToolbarStyled>
  );
};

export default DraggableToolbar;
